import { Button, DataSource, HorizontalSpacer, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutImageTable extends Layout {
    buttonUploadImage: Button;
    horizontalspacer1: HorizontalSpacer;
    sourceImages: DataSource;
    tableImages: Table;
}
